import { useState } from 'react';
import { Loader2, RefreshCw } from 'lucide-react';

/**
 * Экран «Не удалось загрузить баланс» (K-041): вместо «Гость, 0 баллов», когда профиль не загрузился. Нули как
 * значение по умолчанию не показываются — клиент с баллами не должен видеть ноль.
 */
export function ProfileLoadError({ onRetry }: { onRetry: () => Promise<void> }) {
  const [retrying, setRetrying] = useState(false);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-page p-6 text-center text-text-main">
      <p className="text-lg font-semibold">Не удалось загрузить баланс</p>
      <p className="text-sm text-text-muted">
        Ваши баллы на месте — проблема со связью. Попробуйте ещё раз через несколько секунд.
      </p>
      <button
        type="button"
        disabled={retrying}
        onClick={() => {
          setRetrying(true);
          void onRetry().finally(() => setRetrying(false));
        }}
        className="flex items-center gap-2 rounded-xl bg-primary px-5 py-3 font-semibold text-text-on disabled:opacity-60"
      >
        {retrying ? <Loader2 className="animate-spin" size={18} /> : <RefreshCw size={18} />}
        Повторить
      </button>
    </div>
  );
}
